import { getScope3Emissions } from '../../../api/emissionsApi';
import { getHistoricalReport } from '../../../api/historicalReportsApi';
import { createEmptyScope3, normalizeScope3, normalizeHistoricalScope3 } from '../model/emissionScreens';
import useEmissionScreen from './useEmissionScreen';

export default function useScope3Emissions() {
  return useEmissionScreen({
    request: getScope3Emissions,
    normalize: normalizeScope3,
    createEmpty: createEmptyScope3,
    historicalRequest: getHistoricalReport,
    normalizeHistorical: normalizeHistoricalScope3,
  });
}
